import React, { useEffect, useState } from 'react';
import { Typography } from '@/ui-kit';
import styles from './introE.module.scss';
import { generatePath, useNavigate } from 'react-router-dom';
import { useAuth } from '@/store/useAuth';
import { eventsApi } from '@/api';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { ArrowBackIcon } from '@/assets/icons';
import introEMask from '@/assets/images/introAMask.png';
import introE from '@/assets/images/introA.png';
import { routesApp } from '@/constans/routes';
import { SignUpDesign, useSignUpDesign } from '@/store/useSignUpDesign';

export const IntroE: React.FC = () => {
    const { user, emptyFields, getUser, profileWasRemovedError } = useAuth((state) => state);
    const navigate = useNavigate();
    const [isVideoLoaded, setVideoLoaded] = useState(false)

    useEffect(() => {
        let path: string | null = null;

        if (
            emptyFields() ||
            profileWasRemovedError
        ) {
            // Ничего не делаем, если есть незаполненные поля
            eventsApi.updateUserEvent('start_screen');
            callYaMetrika('first_screen_loaded', {
                first_screen: 'E'
            });
            return;
        }

        if (getUser()?.state === 'incomplete') {

            // Если пользователь не завершил регистрацию
            path = generateSignUpPath();
        } else {
            // Если пользователь завершил регистрацию
            path = generatePath(routesApp.browse);
        }

        if (path) {
            navigate(path, { replace: true });
        }
    }, [emptyFields, navigate, user]);

    const registerClick = () => {
        callYaMetrika('clicked_registration_button');
        navigate(
            generateSignUpPath()
        )
    };

    const {
        design: signUpScreen,
        setDesign
    } =
        useSignUpDesign((state) => state)

    // rt15161: a/b test of sign up
    const generateSignUpPath = () => {
        let design: SignUpDesign =
            signUpScreen
        if (user) {
            setDesign(user?.registration_design)
            design = user?.registration_design
        }
        return generatePath(
            design === 'new_skip_steps' ?
                routesApp.registrationV4
            : design === 'new_photo_last' ?
                routesApp.registrationV3
            : design === 'new' ?
                routesApp.registrationV2
            :
                routesApp.registration,
            { stepNumer: '1' }
        );
    }

    return (
        <section className={styles.intro}>
            <img className={styles.introVideoPoster} src={introE} />
            <img className={styles.introVideoBg} src={introEMask} />
            <div className={styles.intro__content}>
                <Typography
                    className={styles.intro__Headline}
                    typeColor="white"
                    variant="h1">
                    Найди свою вторую половинку
                </Typography>
                <Typography
                    typeColor="white"
                    variant="p"
                    className={styles.intro__text}>
                    Euphora — знакомства для любителей путешествовать вместе.
                </Typography>
                <div className={styles.intro__btn} onClick={registerClick}>
                    <span>
                        Найти свою любовь
                    </span>
                    <button className={styles.intro__btnTrailing}>
                        <ArrowBackIcon className={styles.intro__btnTrailingIcon} />
                    </button>
                </div>
                <Typography
                    center
                    className={styles.introFootnote}>
                    Принимаю условия регистрации пользователей.
                </Typography>
                <Typography
                    center
                    className={styles.introFootnote}>
                    Нажимая на кнопку «Найти свою любовь», вы подтверждаете свое согласие с пользовательским соглашением и условиями обработки персональных данных
                </Typography>
            </div>
        </section>
    );
};
